(function($) {
    $(() => {
        
        $('.js-year').on('click', function (e) {
            e.preventDefault();

            let slug = $(this).data('slug');

            $('.js-check').prop('checked', false);

            if ($(`#js_${slug}`).prop('checked')) {
                $(`#js_${slug}`).prop('checked', false)
            } else {
                $(`#js_${slug}`).prop('checked', true)
            }

           $('.js-report-form').submit();
        });
        
        $('#type_select').on('change', function() { 
            console.log($(this).val());
            $('.js-report-form').submit();
        });

        $('.js-report-form').submit(function (e) {

            var years = [];
            $(".js-check").each(function (i) {
                if ($(this).prop('checked')) {
                    years.push($(this).val())
                }
            });

            if (years.length !== 0) {
                $('<input/>').attr('type', 'hidden').attr('name', 'date').attr('value', years).appendTo('.js-report-form');
            }

            if($('#type_select').val() !== 'all') { 
                $('<input/>').attr('type', 'hidden').attr('name', 'type').attr('value', $('#type_select').val()).appendTo('.js-report-form');
            }

            return true;
        });

    });
})(jQuery);
